import { $, $$, isMobile } from '@utils';
import { categoriesSelection } from '@modules/Content/Accordion/Accordion';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-organigram]')) return;

  isMobile.addEventListener('change', () => {
    addEventListeners();
    setStickyTopPosition();
  });

  addEventListeners();
  setStickyTopPosition();
}

function addEventListeners() {
  const buttons = $$('[data-au-anchor]');
  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      organigramAnchor(e);
      categoriesSelection(e);
      datalayerOrganigramCategorieButton(e);
    });
  });
}

function organigramAnchor(e) {
  const category = e.target.getAttribute('data-au-anchor');
  const target = document.querySelector(`[data-au-anchor-content="${category}"]`);

  // if some focusable element on target, focus on first of them
  const focusableElemets = '[href]';
  target.querySelectorAll(focusableElemets).forEach((focusableElement, index) => {
    if (!focusableElement) return;
    if (index === 0) {
      focusableElement.focus();
    }
  });

  const headerHeight = $('.n-main-header-responsive') ? $('.n-main-header-responsive').clientHeight : 0;
  const glossaryAside = $('[data-au-organigram-aside]');
  const asideHeight = isMobile.matches ? glossaryAside.clientHeight : 0;
  const elementPosition = target.getBoundingClientRect().top;
  const offset = elementPosition + window.scrollY;
  const scroll = offset - headerHeight - asideHeight + 2;
  window.scrollTo(0, scroll);

  const buttons = $$('[data-au-anchor]');
  buttons.forEach((e) => {
    e.classList.remove('au-active');
  });
  e.target.classList.add('au-active');
}

function datalayerOrganigramCategorieButton(e) {
  const titleText = e.target
      .closest('[data-au-organigram]')
      .querySelector('[data-au-collapsable-title-text]').innerText,
    clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  const content_type = 'clickBoton';

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

/**
 * Set top px of sticky. Is equal of header height + 16px of space if it exists.
 * If not, just those 16px on desktop and 0 on mobile.
 */
function setStickyTopPosition() {
  const stickyTop = isMobile.matches ? 0 : 16,
    header = $('.n-main-header-responsive'),
    headerHeight = header ? parseInt(getComputedStyle(header).height, 10) + stickyTop : stickyTop;

  $$('[data-au-organigram-aside]').forEach((sticky) => {
    sticky.style.top = `${headerHeight}px`;
  });
}

export default { init };
